<template>
  <div>
    <div v-if="instructStatus && turnType === '3'">
      <el-form :model="commonDetailData" label-width="100px" disabled>
        <el-row>
          <el-col :span="6">
            <el-form-item label="指令单编号">
              <el-input v-model="commonDetailData.instructCode"></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6">
            <el-form-item label="采购组织">
              <el-input v-model="commonDetailData.purchaseOrgName"></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="6">
            <el-form-item label="服务供方">
              <el-input v-model="commonDetailData.serviceProviderName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="指令单状态">
              <el-input v-model="commonDetailData.instructStatus"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="服务下发时间">
              <el-input v-model="commonDetailData.instructIssueDate"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="最近更新时间">
              <el-input v-model="commonDetailData.instructUpdateDate"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="业务完结时间">
              <el-input v-model="commonDetailData.businessComplatedDate"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="common-service" v-else>
      <el-form
        :model="commonFormData"
        ref="commonDataForm"
        label-width="100px"
        :rules="commonDataRules"
      >
        <el-row>
          <!-- <el-col :span="6">
            <el-form-item label="采购组织">
              <el-input v-model="commonFormData.purchaseOrgName" disabled></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="6">
            <el-form-item label="服务供方" prop="serviceProviderCode">
              <el-select
                placeholder="请选择服务供方"
                v-model="commonFormData.serviceProviderCode"
                filterable
                clearable
                @change="handleChange"
                :disabled="!disabledFlag"
              >
                <el-option
                  v-for="(item, index) in serviceProviderList"
                  :key="index"
                  :label="item.supplierName"
                  :value="item.supplierCode"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
  import orderMixin from '@/pages/intermodality/order/orderMixin';
  import XEUtils from 'xe-utils';
  import { orderStatusList } from '../data';
  export default {
    name: 'commonService',
    mixins: [orderMixin],
    props: [
      'purchaseOrgName',
      'commonServiceArr',
      'turnType',
      'currStatus',
      'contractRelationInfo',
    ],
    data() {
      return {
        commonFormData: {
          purchaseOrgName: '', // 合同中带出的销售组织
          serviceProviderCode: '',
          instructStatus: '',
        },
        commonDetailData: {
          instructCode: '',
          purchaseOrgName: '',
          serviceProviderName: '',
          instructStatus: '',
          instructIssueDate: '',
          instructUpdateDate: '',
          businessComplatedDate: '',
        },
        // serviceProviderList: [],
        instructStatus: '',
        orderStatusList,
      };
    },
    created() {
      console.log();
      this.getServiceProviderList();
      // this.commonFormData.purchaseOrgName = this.purchaseOrgName;
    },
    mounted() {
      this.initData();
    },
    computed: {
      disabledFlag() {
        console.log(
          this.turnType,
          '----------------------------------------------------------------',
          this.instructStatus
        );
        if (['0', '2'].includes(this.turnType)) {
          return true;
        }
        return this.turnType === '3' || (this.turnType === '1' && this.instructStatus !== 'draft');
      },
      commonDataRules() {
        return {
          serviceProviderCode: [{ required: true, message: '服务供方必选', trigger: 'change' }],
        };
      },
    },
    watch: {
      commonServiceArr(newVal) {
        this.commonServiceArr = newVal;
        if (
          this.turnType === '3' ||
          this.turnType === '1' ||
          this.turnType === '2' ||
          this.turnType === '0'
        ) {
          this.detailCommon();
        }
      },
      // purchaseOrgName(newVal) {
      //   this.purchaseOrgName = newVal;
      //   if (this.turnType === '1') {
      //     this.commonFormData.purchaseOrgName = this.purchaseOrgName;
      //   }
      // },
      contractRelationInfo(val) {
        if (val) {
          this.contractRelationInfo = val;
          this.initData();
        }
      },
    },
    methods: {
      detailCommon() {
        if (this.commonServiceArr.length > 0) {
          const commonObj = this.commonServiceArr[0] || {};
          console.log(commonObj, '111111');
          this.instructStatus = commonObj.instructStatus || '';
          if (this.instructStatus && this.turnType === '3') {
            // 详情
            const objDetail = {
              instructCode: commonObj.instructCode || '',
              purchaseOrgName: commonObj.purchaseOrgName || '',
              serviceProviderName: commonObj.serviceProviderName || '',
              instructStatus: this.transferSelect(commonObj.instructStatus, this.orderStatusList),
              instructIssueDate: commonObj.instructIssueDate || '',
              instructUpdateDate: commonObj.instructUpdateDate || '',
              businessComplatedDate: commonObj.businessComplatedDate || '',
            };
            Object.assign(this.commonDetailData, objDetail);
          } else {
            // 编辑 复制
            // const obj = {
            //   purchaseOrgName: commonObj.purchaseOrgName || '',
            //   purchaseOrgCode: commonObj.purchaseOrgCode || '',
            //   serviceProviderCode: commonObj.serviceProviderCode || '',
            //   serviceProviderName: commonObj.serviceProviderName || '',
            //   instructStatus: commonObj.instructStatus,
            // };
            const obj = commonObj;
            Object.assign(this.commonFormData, obj);
          }
        }
      },
      initData() {
        this.commonFormData.purchaseOrgName = this.contractRelationInfo.saleDepartmentName;
      },
      handleChange(val) {
        this.serviceProviderList.forEach((service) => {
          if (service.supplierCode === val) {
            this.commonFormData.serviceProviderName = service.supplierName;
          }
        });
      },
      transferSelect(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
    },
  };
</script>
